import {Vehicle} from '../../../../gql/customer/graphql.ts';
import modalStyles from '../../../../components/modal/modal.module.scss';
import {List} from '../../../../components/list/list.tsx';
import React, {useCallback} from 'react';
import {useClickOutside} from '../../../../support/use_click_outside.ts';
import listStyles from '../../../../components/list/list.module.scss';
import {VehicleLogo} from '../../../../components/vehicle/vehicle_logo.tsx';
import {Spacer} from '../../../../components/utility/spacer.tsx';
import {VehicleBrandModel, VehicleBrandModelSize} from '../../../../components/vehicle/vehicle_brand_model.tsx';
import {Alignment} from '../../../../enums/alignment.ts';
import {Identifier} from '../../../../components/identifier/identifier.tsx';
import {ListItem} from '../../../../components/list/list_item.tsx';
import {LocationType} from '../../../../gql/pwa/graphql.ts';
import {Icon} from '../../../../components/icon/icon.tsx';
import {Button} from '../../../../components/button/button.tsx';
import {ButtonColorType} from '../../../../enums/button_color_type.ts';
import {__} from '../../../../support/lang/translations.ts';
import buttonStyles from '../../../../components/button/button.module.scss';
import {brandLogo} from '../../../../support/brand_logo.ts';

interface OwnProps {
    onCloseModal: () => void;
    onAccept: () => void;
    vehicle: Vehicle;
    location: LocationType;
}

export function ReviewPrefilledInfoModal(props: OwnProps) {
    const ref = React.useRef<HTMLDivElement | null>(null);
    const {onCloseModal} = props;
    const closeModalCallback = useCallback(() => {
        onCloseModal();
    }, [onCloseModal]);
    useClickOutside(ref, closeModalCallback);
    const vehicleName = `${props.vehicle?.brand} ${props.vehicle?.model}`;
    const locationName = props.location?.name || '';

    return (
        <div className={modalStyles.modal_backdrop}>
            <div className={modalStyles.modal}>
                <div className={modalStyles.modal_dialog} ref={ref}>
                    <div className={modalStyles.modal_header}>
                        <span />
                        <h2>
                            {__('appointment.review_prefilled.title', {vehicle: vehicleName, location: locationName})}
                        </h2>
                        <button type="button" onClick={() => props.onCloseModal()}>
                            <i className="fa-light fa-close"></i>
                        </button>
                    </div>
                    <div className={modalStyles.modal_body}>
                        <List>
                            <ListItem key={props.vehicle.id}>
                                <div className={listStyles.list__item_content}>
                                    <VehicleLogo alt={props.vehicle.model ?? ''} src={brandLogo(props.vehicle.brand)} />
                                    <Spacer />
                                    <VehicleBrandModel
                                        brand={props.vehicle.brand ?? ''}
                                        model={props.vehicle.model ?? ''}
                                        size={VehicleBrandModelSize.Small}
                                        alignment={Alignment.Start}
                                    />
                                </div>
                                <div className={listStyles.list__item_content}>
                                    <Identifier
                                        identifier={
                                            props.vehicle.identifiers?.find((id) => id?.type === 'license_plate')
                                                ?.value ?? ''
                                        }
                                    />
                                </div>
                            </ListItem>
                            <ListItem>
                                <div className={listStyles.list__item_content}>
                                    <Icon src={props.location.photo_url ?? ''} />
                                    <Spacer />
                                    <span>{props.location.name}</span>
                                </div>
                            </ListItem>
                        </List>
                        <div className={modalStyles.modal_footer}>
                            <Button
                                className={buttonStyles.button_step}
                                type="button"
                                onClick={() => props.onCloseModal()}
                                colorType={ButtonColorType.Black}
                            >
                                <i className="fa-light fa-pen" />
                                <span>{__('appointment.review_prefilled.footer.buttons.select')}</span>
                            </Button>
                            <Button
                                className={buttonStyles.button_step}
                                type="button"
                                onClick={() => props.onAccept()}
                                colorType={ButtonColorType.Green}
                            >
                                <i className="fa-light fa-check" />
                                <span>{__('appointment.review_prefilled.footer.buttons.next')}</span>
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
